import { useLocation } from 'react-router-dom-v7'
import { useInitialData } from './useInitialData'

export function useB2BHeaderAndFooterData() {
    const location = useLocation()
    const { b2bHeadersAndFooters } = useInitialData()

    return b2bHeadersAndFooters?.find(x => {
        return location.pathname.toLocaleLowerCase().startsWith(x.b2BPage.url.toLocaleLowerCase())
    })
}
